import axios from 'axios';






const authService = {
    
    user: null,
    clearAuth(){
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('ACCESS_TOKEN_EXPIRE');
        localStorage.removeItem('USERNAME');
        localStorage.removeItem('USERID');
        localStorage.removeItem('SUPERADMIN');
        localStorage.removeItem('USERTYPE');
        localStorage.removeItem('PERMISSIONS');
        localStorage.removeItem('LANGUAGE');
        localStorage.removeItem('LANGUAGEID');
        localStorage.removeItem('LANGUAGENAME');
        localStorage.removeItem('BADGEHIDDEN');
    },
   async Login(formData,lan_id){
    try {
        const {status, data} = await axios.post('/user/login?id='+lan_id,formData);
        console.log(status,data);
        const detailsArray =  JSON.stringify(data.details);
        console.log(detailsArray);
        //this.token = data.access_token;
       if(status === 200){
        this.setUser(data);
        const permissionsArray = data.permistion;
        localStorage.setItem('PERMISSIONS', JSON.stringify(permissionsArray));

        const detailsArray = data.details;
        localStorage.setItem('LANGUAGE', JSON.stringify(detailsArray));
          return {success: true}; 
       }
      } catch (error) {
        console.log(error.response);
        this.errorsf = error.response.data.errors.username
        this.errors2f = error.response.data.errors.password
        if( this.errorsf){
            this.errors = error.response.data.errors.username[0];
        }
        if( this.errors2f){
            this.errors2 = error.response.data.errors.password[0];
        }
        
        return {
            success: false,
            errors: this.errors,
            errors2: this.errors2,
            
            
        }
      }
    },

    
    setUser(data){
       
        localStorage.setItem('ACCESS_TOKEN', data.user.access_token);
        localStorage.setItem('ACCESS_TOKEN_EXPIRE', String(data.user.access_token_expire || data.access_token_expire || ''));
        localStorage.setItem('USERNAME', data.user.username);
        localStorage.setItem('USERID', data.user.id);
        localStorage.setItem('SUPERADMIN', data.user.superadmin);
        localStorage.setItem('USERTYPE', data.usertype || data.user.usertype || data.user.user_type || '');
        localStorage.setItem('LANGUAGENAME', data.lan_name);
 
        const permissionsArray = data.permistion;
       localStorage.setItem('PERMISSIONS', JSON.stringify(permissionsArray));

       const detailsArray = data.details;
       localStorage.setItem('LANGUAGE', JSON.stringify(detailsArray));
     // localStorage.setItem('PERMISSIONS', permissionsArray);
       localStorage.setItem('BADGEHIDDEN', false);
   
     if(localStorage.getItem('LANGUAGEID')){
        localStorage.setItem('LANGUAGEID', data.lan_id);
     }else{
        localStorage.setItem('LANGUAGEID', 1);
     }
        
    
      

// Now you can use the permissionsArray as a regular array
       
    },
    isLoggedIn(){
        const token = localStorage.getItem('ACCESS_TOKEN');
        if (!token) {
            return null;
        }

        const expireAt = parseInt(localStorage.getItem('ACCESS_TOKEN_EXPIRE') || '0', 10);
        if (expireAt && Date.now() >= expireAt * 1000) {
            this.clearAuth();
            return null;
        }

        return token;
       
    },

    isUsername(){
        return localStorage.getItem('USERNAME');
    },
    isDemoUser(){
        const username = localStorage.getItem('USERNAME') || '';
        return username.toLowerCase() === 'demo';
    },
    isUsertype(){
        return localStorage.getItem('USERTYPE') || '';
    },
    isCrcUser(){
        const usertype = (localStorage.getItem('USERTYPE') || '').trim().toUpperCase();
        return usertype === 'CRC';
    },
    isQuickserveUser(){
        const usertype = (localStorage.getItem('USERTYPE') || '').trim().toUpperCase();
        return usertype === 'QUICKSERVE';
    },
    isUserid(){
        return localStorage.getItem('USERID');
    },
    isSuperadmin(){
        return localStorage.getItem('SUPERADMIN');
    },
    isPermission(){
        return localStorage.getItem('PERMISSIONS');
    },
    hasPermission(path){
        const permissions = JSON.parse(localStorage.getItem('PERMISSIONS') || '[]');
        return permissions.some(permission => permission.permission_name === path);
    },
    isLanguage(){
        return localStorage.getItem('LANGUAGE');
    },
    isLanguageid(){
        return localStorage.getItem('LANGUAGEID');
    },
    isLanguagename(){
        return localStorage.getItem('LANGUAGENAME');
    },
    isBadgehidden(){
        return localStorage.getItem('BADGEHIDDEN');
    },

    
    
    
    Logout(vm){
        
       
        this.clearAuth();
        if (vm && vm.$router) {
    vm.$router.push({ name: 'LoginView' });
  } else {
    console.warn('Router not available for redirect');
  }
     
        
    }
};



export default authService;
